import { SWR_KEYS } from 'constants/constants';
import { countriesList } from 'services/countriesList';
import useSWR from 'swr';

export function useListCountries() {
  const {
    data: countries,
    error: countriesError,
    isLoading: areCountriesLoading
  } = useSWR([SWR_KEYS.listCountries, countriesList], ([_, fetcher]) => fetcher());

  return { countries, countriesError, areCountriesLoading };
}
